// The page's side of the media relay, the service worker in public/mediaRelay.js that answers a
// player's element from a single download of the copy (the worker says how).
//
// The worker is registered as the drive starts, so that it is already looking after the page by the
// time anything is played. A player opened before then, or in a browser without service workers,
// plays straight from the copy as it always did — so whether a player goes through the relay is
// settled once, as it opens, and never changes under a file that is playing.
//
// A player that goes through it gets a key of its own and an address for its element made from the
// key and the copy's url. While it is open it asks the worker after its download every second,
// which keeps the worker going while the file arrives and brings back how much has. Closing it lets
// the download go.
const SCRIPT = '/mediaRelay.js'
const RELAY = '/media-relay/'
const ASK_EVERY = 1000

export const startMediaRelay = () => navigator.serviceWorker?.register(SCRIPT).catch(() => {})

// Development mounts every component twice over. A player put back at once takes its download back,
// rather than letting it go and starting the file again.
const closing = new Map()

export const openMediaRelay = () => {
  const worker = navigator.serviceWorker?.controller

  if (!worker) return null

  const key = crypto.randomUUID()

  return {
    source: src => `${RELAY}${key}?src=${encodeURIComponent(src)}`,

    follow: onProgress => {
      const hear = ({data}) => data?.relay === key && onProgress({bytes: data.received, of: data.total})
      const ask = () => worker.postMessage({keep: key})
      const asking = setInterval(ask, ASK_EVERY)

      clearTimeout(closing.get(key))
      navigator.serviceWorker.addEventListener('message', hear)
      ask()

      return () => {
        clearInterval(asking)
        navigator.serviceWorker.removeEventListener('message', hear)
        closing.set(key, setTimeout(() => {
          closing.delete(key)
          worker.postMessage({close: key})
        }))
      }
    }
  }
}
